import { useCopilot } from '@/providers/copilot-provider';
import { useFeedback as useFeedbackContext } from '@/contexts/FeedbackContext';
import type { FeedbackContext as FeedbackContextType } from '@/types/feedback';

export function useFeedback() {
  const { setIsVisible, setCopilotMode } = useCopilot();
  const { openFeedback: openFeedbackContext, ...rest } = useFeedbackContext();

  return {
    ...rest,
    openFeedback: (context: FeedbackContextType) => {
      setIsVisible(true);
      setCopilotMode('feedback');
      openFeedbackContext(context);
    }
  };
}
